// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-details-main-div {
  padding-bottom: 110px;
  overflow-x: hidden !important;
}

.product-details-div {
  display: flex;
  flex-direction: column;
  height: 150vh;
  overflow: hidden;
  padding: 25px 228px 22px 18px;
  align-items: center;
  flex-shrink: 0;
  background: #f5f5f5;
}
.select-campaign-drawer-title {
  color: #000;
  font-family: Montserrat;
  font-size: 19px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.product-details-arrow-and-text-row {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  margin-left: -14px;
}
.product-details-back-button-details {
  padding-left: 0px;
  padding-right: 0px;
}
.product-date-arrow-outlined {
  margin-left: 3% !important;
  margin-right: 3% !important;
  stroke-width: 1px !important;
  color: #d2042d !important;
}
.fixed-addto-campaign-btn-card {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  width: 430px;
  height: 148px;
  flex-shrink: 0;
  border-radius: 10px 10px 0px 0px;
  background: #fff;
  box-shadow: 0px -2px 30px 0px rgba(0, 0, 0, 0.21);
}

.product-details-arrow-and-text-div {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
  margin-top: 1rem !important;
  margin-left: 20px !important;
}

.product-details-back-icon {
  height: 0px;
  flex-shrink: 0;
  stroke-width: 2px;
  stroke: #000;
  width: 30px !important;
  margin-left: 1rem !important;
  margin-top: -2rem !important;
}

.product-details-arrow-and-text-div .product-details-heading {
  color: var(--Colors-Text-500, #0a0f0d);
  font-family: Montserrat;
  font-size: var(--Font-Font-Size-h6, 19px);
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: -1.6rem !important;
  margin-left: -2% !important;
}

.product-availabale-card {
  width: calc(100% - 36px);
  max-width: 394px;
  height: auto;
  flex-shrink: 0;
  border-radius: 10px;
  background: #fff;
  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.08);
  margin-left: 18px !important;
  margin-right: 18px !important;
  margin-top: -0.5rem !important;
}

.product-iamge-card {
  width: calc(100% - 36px);
  max-width: 394px;
  height: auto;
  flex-shrink: 0;
  border-radius: 10px;
  margin-left: 18px !important;
  margin-right: 18px !important;
  margin-top: 0.5rem !important;
}

.product-data-div {
  margin-left: -1% !important;
}

.product-id {
  color: var(--Colors-Primary-500, #d2042d);

  font-size: var(--Font-Font-Size-small, 13px);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.product-title {
  color: #000;
  font-size: var(--Font-Font-Size-p, 14px);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 1% !important;
}

.product-available-from {
  width: 86px;
  color: var(--Colors-Text-200, #8e9190);

  font-size: var(--Font-Font-Size-small, 13px);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.product-available-dates {
  color: #000;

  font-size: var(--Font-Font-Size-small, 13px);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.no-of-selected-days-card .ant-card {
  max-width: 394px;
  width: calc(100% - 36px);
  flex-shrink: 0;
  border-radius: 10px;
  background: #fff;
  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.08);
  margin-left: 18px !important;
  margin-right: 18px !important;
  margin-top: 1rem !important;
}
.centered-col-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.scrollable-col-container {
  display: flex;
  overflow-x: auto;
  gap: 10px;
}

.no-of-days-selected-heading {
  color: var(--Colors-Text-300, #5b5e5d);

  font-size: var(--Font-Font-Size-small, 13px);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.available-dates-div .dates-btn-arrow .anticon {
  width: 11px;
  height: 0px;
  flex-shrink: 0;
  stroke-width: 1px;
  stroke: var(--Colors-Primary-500, #d2042d);
}

.selected-days {
  color: #000;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  color: #000;

  font-size: var(--Font-Font-Size-small, 13px);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.product-saved-campaign-card .ant-card {
  max-width: 394px;
  height: 84px;
  width: calc(100% - 36px);
  flex-shrink: 0;
  border-radius: 10px;
  background: #fff;
  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.08);
  margin-left: 18px !important;
  margin-right: 18px !important;
  margin-top: 1rem !important;
}

.no-of-selected-days-heading {
  color: var(--Colors-Text-300, #5b5e5d);

  font-size: var(--Font-Font-Size-small, 13px);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.select-campaign-heading {
  color: var(--Colors-Text-300, #5b5e5d);

  font-size: var(--Font-Font-Size-small, 13px);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.select-campaign-existing-list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 10px 0;
  gap: 16px !important;
}
.campaign-drawer-mobile .ant-drawer-body {
  padding-top: 0% !important;
}
.radio-list {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
.radio-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  display: flex;
  gap: 2%;
  flex-wrap: nowrap;
}
.select-campaign-existing-list-rdio-btn {
  width: 4%;
  order: 2;
  margin-left: 34rem;
  transform: scale(1.3);
}
.select-campaign-existing-list-rdio-btn .ant-radio-inner {
  width: 1rem !important;
  height: 1rem !important;
}

.select-campaign-existing-list-rdio-btn .ant-radio {
  transform: scale(1.5);
}
.select-campaign-existing-list .ant-radio {
  order: 1;
  margin-inline-end: 2rem !important;
}

.select-campaign-existing-list span {
  white-space: nowrap;
}

.select-campaign-existing-list .campaign-radio-btn-grp {
  display: flex;
  flex-direction: column;
  gap: 2rem !important;
  width: 100%;
}

.select-campaign-existing-list .ant-radio-wrapper span.ant-radio + * {
  padding-inline-start: 8px;
  padding-inline-end: 10rem;
}

.select-campaign-existing-list-text {
  width: 80%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: var(--Colors-Text-400, #3b3f3d);
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.campaign-divider-mobile {
  border-radius: 1px solid !important;
}
.select-campaign-apply-btn {
  display: flex;
  height: 3.125rem;
  padding: 0.5rem 2.125rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
  border-radius: 0.3125rem;
  background: #d2042d;
  margin-bottom: 1rem;
  width: 100% !important;
}

.select-campaign-existing-list {
  flex: 1 1;
  max-height: 60vh;
  overflow-y: auto;
  padding: 10px;
  border-bottom: 2px solid #ddd;
  overflow-x: hidden;
}

.radio-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.radio-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0.5rem 0;
}

.select-campaign-existing-list-text {
  color: var(--Colors-Text-400, #3b3f3d);
  font-size: 1rem;
  font-weight: 500;
  white-space: nowrap;
}

.select-campaign-existing-list-rdio-btn {
  transform: scale(1.3);
  margin-left: 0;
}

.campaign-drawer-mobile .ant-drawer-body {
  padding-top: 0% !important;
}
.select-campaign-container {
  display: flex;
  flex-direction: column;
  height: 125%;
  padding: 0px 18px;
}
.select-campaign-footer {
  bottom: 0;
}

.select-campaign-apply-btn-text {
  color: #fff;
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.create-new-campaign-tittle {
  color: #000;
  font-family: Montserrat;
  font-size: 19px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 25px;
}
.create-new-campaign-row {
  margin-bottom: 5% !important;
  margin-top: 20px;
}
.create-new-campaign-cancel-btn .ant-btn-variant-solid {
  display: flex;
  width: 132px;
  height: 40px;
  padding: 8px 20px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 5px;
  background: #fff;
}

.create-new-campaign-cancel-btn {
  display: flex;
  width: 100%;
  height: 40px;
  padding: 8px 20px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border: 1px solid #000;
  background: #fff;
}

.create-new-campaign-cancel-btn:focus,
.create-new-campaign-cancel-btn:active {
  background-color: none !important;
}
.mobile-create-new-campaign-btn {
  display: flex;
  height: 3.125rem;
  padding: 0.5rem 2.125rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
  border-radius: 0.3125rem;
  border: 1px solid #000;
  background: #fff !important;
  width: 100%;
}

.create-new-campaign-cancel-btn-text {
  color: var(--Colors-Text-500, #0a0f0d);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.mobile-create-new-campaign-btn-text {
  color: #0a0f0d;
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.new-create-campaign-btn-container {
  margin-top: 20px;
}
.create-new-campaign-confirm-btn-text {
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.create-new-campaign-confirm-btn.ant-btn-variant-solid {
  display: flex;
  width: 100%;
  height: 40px;
  padding: 8px 20px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 5px;
  background: #d2042d !important;
}
.create-new-capaign-col-cancel
  .ant-btn-variant-solid:not(:disabled):not(.ant-btn-disabled):hover {
  background: #fff;
  color: #fff;
}
.create-new-capaign-col-confirm
  .ant-btn-variant-solid:not(:disabled):not(.ant-btn-disabled):active {
  background: #d2042d;
  color: #fff;
}
.selected-days {
  color: #000;

  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.campaign-list {
  color: #000;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.calendar-container {
  border: none !important;
}
.ant-picker-dropdown .ant-picker-cell-disabled::before {
  background: none !important;
}

.calendar-main-row {
  margin-top: -1rem !important;
}

.date-picker-calendar {
  border: none !important;
}

.custom-date-picker {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.custom-date-picker .ant-picker-suffix {
  border: none !important;
  background: none !important;
  padding: 0;
  box-shadow: none;
}

.custom-date-picker .ant-picker-input {
  display: none;
}

.custom-calendar-popup-mobile .ant-picker-panel-container {
  display: flex;
  flex-direction: column;
  justify-content: center !important;
  align-items: center !important;
  width: 90%;
  margin-right: auto !important;
  margin-left: auto !important;
  height: auto !important;
  flex-shrink: 0;
  box-shadow: none;
  border-radius: 12.133px;
  border: 1.213px solid #ddd;
  background: #fff;
  caret-color: transparent !important;
}

.ant-picker-input > input {
  caret-color: transparent !important;
  cursor: pointer;
}

.custom-calendar-popup-mobile .ant-picker-panel {
  width: 100%;
}

.custom-calendar-popup-mobile .ant-picker-panel:nth-child(2) {
  display: none !important;
}

.create-new-capaign-col-cancel .ant-btn-primary:hover {
  background-color: none !important;
}
.selected-days-heading {
  font-size: 14px;
  font-weight: bold;
  color: #555;
}

.custom-calendar-popup-mobile .ant-picker-cell-selected .ant-picker-cell-inner {
  background-color: transparent !important;
  box-shadow: none !important;
  border: none !important;
}

.custom-calendar-popup-mobile .ant-picker-cell-selected .ant-picker-cell-inner {
  background-color: #d2042d !important;
  color: white !important;
  border: #d2042d !important;
}

.custom-calendar-popup-mobile
  .ant-picker-dropdown
  .ant-picker-cell-in-view.ant-picker-cell-today
  .ant-picker-cell-inner::before {
  border: none !important;
}

.custom-calendar-mobile.ant-picker-outlined {
  border: none !important;
  justify-content: end;
  padding: 0;
  margin: 0;
}

.custom-calendar-mobile.ant-picker .ant-picker-suffix {
  color: white !important;
  opacity: 1 !important;
  /* display: none !important; */
}

.custom-calendar-mobile .ant-picker-selector {
  display: none !important;
}

.custom-calendar-mobile .ant-picker-input {
  display: none !important;
}

.confirm-calendar-btn-text {
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.cancel-calendar-btn-text {
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.confirm-calendar-btn.ant-btn-variant-solid {
  display: flex;
  width: 132px;
  height: 40px;
  padding: 8px 20px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 5px;
  background: #d2042d;
}

.cancel-calendar-btn.ant-btn-variant-solid {
  display: flex;
  width: 132px;
  height: 40px;
  padding: 8px 20px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 5px;
  background: #d2042d;
}

.cancel-calendar-btn {
  display: flex;
  width: 132px;
  height: 40px;
  padding: 8px 20px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 5px;
  background: #d2042d;
}

.cancel-calendar-btn:focus,
.cancel-calendar-btn:active {
  background-color: none !important;
}

.calender-icon {
  padding: 0;
  margin: 0;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  fill: #000;
  position: absolute !important;
  right: 10px !important;
  top: 10px !important;
  cursor: pointer;
}
.add-to-campaign-btn-version {
  text-align: center;
  margin-top: 10px !important;
}
.calendar-footer-btn-row {
  margin-bottom: 5% !important;
  margin-left: 0.7rem !important;
}

.custom-calendar-popup-mobile .ant-picker-content th {
  color: #b3b3b3;
  text-align: center;
  font-size: 15.967px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  width: 41.761px;
  height: 41.761px;
  flex-shrink: 0;
}

.custom-calendar-popup-mobile
  .ant-picker-cell-today
  .ant-picker-cell-inner::before {
  border: none !important;
}

.custom-calendar-popup-mobile .ant-picker-cell-today .ant-picker-cell-inner {
  border: 1px solid #d2042d !important;
}

.calendar-btns-above-divider {
  width: 282.5px;
  height: 0px;
  flex-shrink: 0;
  stroke-width: 0.614px;
  stroke: #a3a3a6;
}

.custom-calendar-popup-mobile .ant-picker-header {
  padding: 0px 18px;
  width: 100% !important;
}

.custom-calendar-popup-mobile .ant-picker-header-prev-btn,
.custom-calendar-popup-mobile .ant-picker-header-next-btn {
  justify-content: center;
}

.date-picker-calendar .ant-picker-outlined:hover {
  border-color: none !important;
}

.mobile-image-scrollable-container {
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
  padding: 10px;
  gap: 16px;
  margin-left: 0.5rem !important;
  width: 100%;
}

.scrollable-col-container {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
}

.images-width-div {
  width: calc(100% - 7px);
  max-width: 400px;
}

.scrollable-col-container::-webkit-scrollbar {
  display: none;
}

.image-wrapper {
  display: flex;
  gap: 16px;
}

.mobile-billboard-img {
  width: 100%;
  max-width: 252px;
  height: 150px;
  flex-shrink: 0;
  border-radius: 10px;
}

@media (max-width: 768px) {
  .scrollable-col-container {
    overflow-x: auto;
    justify-content: flex-start;
  }
  .mobile-billboard-img {
    width: 100%;
    max-width: 252px;
    height: 150px;
    flex-shrink: 0;
    border-radius: 10px;
  }
}

@media (min-width: 768px) {
  .scrollable-col-container {
    justify-content: center;
  }
}

.product-information-card {
  width: calc(100% - 36px);
  min-height: 720px !important;
  max-width: 394px;
  height: auto !important;
  flex-shrink: 0;
  border-radius: 10px;
  background: #fff;
  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.08);
  margin-left: 18px !important;
  margin-right: 18px !important;
  margin-top: 1rem !important;
}

.product-information-card-row {
  margin-top: 2% !important;
}

.product-information-card-label {
  align-self: stretch;
  color: var(--Colors-Text-200, #8e9190);

  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.product-information-card-value {
  align-self: stretch;
  color: var(--Colors-Text-500, #0a0f0d);

  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;

  margin-top: 2% !important;
}

.input-group {
  margin-bottom: 15px;
}

.billboard-img {
  width: 100%;
  border-radius: 10px;
}

.price-footer {
  text-align: center;
  margin-top: 20px;
}

.description-addto-campaign-btn {
  width: 316px;
}

.description-addto-campaign-btn
  .description-addto-campaign-cost-text
  .ant-typography {
  color: var(--Colors-Text-300, #5b5e5d);
  font-size: var(--Font-Font-Size-small, 77px);
  font-style: normal;
  font-weight: 400;
  line-height: 18.2px;
}

.description-addto-campaign-cost-price {
  color: var(--Colors-Text-500, #0a0f0d);
  font-size: var(--Font-Font-Size-h6, 19px);
  font-style: normal;
  font-weight: 800;
  line-height: normal;
}
.mobile-add-to-campaign-btn:hover {
  background-color: #d2042d !important;
  color: #fff;
}

@media (max-width: 768px) {
  .product-details-back-icon {
    width: 35px !important;
    margin-top: -2.2rem !important;
    margin-left: 1.2rem !important;
  }

  .product-details-arrow-and-text-div .product-details-heading {
    font-size: 20px !important;
    margin-top: -1.6rem !important;
    margin-left: -2% !important;
  }

  .product-availabale-card {
    max-width: 100%;
    margin-right: 2rem !important;
  }

  .product-details-heading .ant-typography h1 {
    font-size: 25px;
    font-weight: 700;
  }

  .no-of-selected-days-card .ant-card {
    max-width: 100%;
  }

  .product-saved-campaign-card .ant-card {
    max-width: 100%;
  }

  .product-information-card {
    width: calc(100% - 36px);
    max-width: 100% !important;
    height: auto !important;
    min-height: 720px !important;
    /* max-height: 1430px !important; */
    flex-shrink: 0;
    margin-left: 17px !important;
    margin-right: 12px !important;
    margin-top: 1rem !important;
  }

  .product-information-card-row {
    margin-top: 1% !important;
  }

  .product-information-card-label {
    font-size: 20px;
    font-weight: 400px;
  }

  .product-information-card-value {
    font-size: 16px;
    font-weight: 500px;
  }

  .product-information-card-col {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }

  .product-information-card-label {
    margin-right: 10px;
  }

  .mobile-billboard-img {
    max-width: 100% !important;
  }

  .fixed-addto-campaign-btn-card {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 100;

    height: 148px;
    flex-shrink: 0;
    border-radius: 10px 10px 0px 0px;
    background: #fff;
    box-shadow: 0px -2px 30px 0px rgba(0, 0, 0, 0.21);
  }

  .description-addto-campaign-cost-text {
    color: var(--Colors-Text-300, #5b5e5d);

    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 18.2px;
  }

  .description-addto-campaign-cost-price .ant-typography {
    color: var(--Colors-Text-500, #0a0f0d);
    font-size: var(--Font-Font-Size-h6, 20px);
    font-style: normal;
    font-weight: 800;
    line-height: normal;
  }

  .mobile-add-to-campaign-btn {
    font-size: 20px;
    font-weight: 500px;
    color: #fff;
    display: flex;
    width: 100%;
    height: 50px;
    padding: 8px 20px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    border-radius: 5px;
    opacity: 0.5;
    background: #d2042d;
    margin-right: -10rem !important;
  }
  .no-of-selected-days-heading {
    color: var(--Colors-Text-300, #5b5e5d);
    font-size: var(--Font-Font-Size-small, 16px);
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  .product-available-dates {
    color: #000;
    font-size: var(--Font-Font-Size-small, 16px);
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  .product-available-from {
    width: 86px;
    color: var(--Colors-Text-200, #8e9190);
    font-size: var(--Font-Font-Size-small, 16px);
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  .select-campaign-heading {
    color: var(--Colors-Text-300, #5b5e5d);
    font-size: var(--Font-Font-Size-small, 16px);
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
}

@media screen and (max-width: 600px) {
  .product-details-back-icon {
    width: 32px !important;
    margin-top: -2rem !important;
    margin-left: 1rem !important;
  }

  .product-details-arrow-and-text-div .product-details-heading {
    font-size: 19px;
    margin-top: -1.5rem !important;
    margin-left: -2% !important;
  }

  .product-availabale-card {
    width: calc(100% - 36px);
  }

  .description-addto-campaign-cost-text {
    color: var(--Colors-Text-300, #5b5e5d);
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 18.2px;
  }

  .description-addto-campaign-cost-price .ant-typography {
    color: var(--Colors-Text-500, #0a0f0d);

    font-size: var(--Font-Font-Size-h6, 20px);
    font-style: normal;
    font-weight: 8000;
    line-height: normal;
  }
}

/* 📱 Small Mobile View */
@media (max-width: 425px) {
  .product-details-back-icon {
    width: 30px !important;
    margin-top: -1.8rem !important;
    margin-left: 0.8rem !important;
  }

  .product-details-arrow-and-text-div .product-details-heading {
    font-size: 18px;
    margin-top: -1.4rem !important;
    margin-left: -1.5% !important;
  }

  .product-availabale-card {
    width: calc(100% - 36px);
  }

  .product-information-card {
    width: calc(100% - 36px);
    max-width: 100% !important;
    height: auto !important;
    min-height: 720px !important;
    /* max-height: 1430px !important; */
    flex-shrink: 0;
    margin-left: 16px !important;
    margin-right: 12px !important;
    margin-top: 1rem !important;
  }

  .product-information-card-label {
    font-size: 16px;
    font-weight: 400px;
  }

  .product-information-card-value {
    font-size: 14px;
    font-weight: 400px;
  }

  .product-information-card-col {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }

  .product-information-card-label {
    margin-right: 10px;
  }

  .no-of-selected-days-card .ant-card {
    max-width: 100%;
  }

  .product-saved-campaign-card .ant-card {
    max-width: 100%;
  }

  .ant-card-body .product-information-card-row {
    margin-left: none !important;
    margin-right: none !important;
  }

  .description-addto-campaign-cost-text {
    color: var(--Colors-Text-300, #5b5e5d);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 14.2px;
  }

  .description-addto-campaign-cost-price .ant-typography {
    color: var(--Colors-Text-500, #0a0f0d);
    font-size: var(--Font-Font-Size-h6, 18px);
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
  .create-new-campaign-tittle {
    color: #000;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 550;
    line-height: normal;
    margin-bottom: 25px;
  }
  .selected-days {
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  .login-to-access-campaign-popover-tittle.ant-typography {
    color: #000;
    font-family: Montserrat;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-align: center;
    max-width: 100%;
  }
  .login-to-access-campaign-popover-text.ant-typography {
    color: #000;
    text-align: center !important;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 1rem;
  }
}
.product-version-spin {
  display: flex;
  justify-content: center;
  align-items: center;
}
@media screen and (max-width: 375px) {
  .product-information-card {
    width: calc(100% - 36px);
    max-width: 100% !important;
    height: auto !important;
    min-height: 720px !important;
    max-height: 1540px !important;
    flex-shrink: 0;
    margin-left: 16px !important;
    margin-right: 12px !important;
    margin-top: 1rem !important;
  }

  .product-details-back-icon {
    width: 28px !important;
    margin-top: -1.5rem !important;
    margin-left: 0.5rem !important;
  }

  .product-details-arrow-and-text-div .product-details-heading {
    font-size: 17px;
    margin-top: -1.2rem !important;
    margin-left: -1% !important;
  }

  .product-availabale-card {
    width: calc(100% - 36px);
  }

  .no-of-selected-days-card .ant-card {
    max-width: 100%;
  }

  .product-saved-campaign-card .ant-card {
    max-width: 100%;
  }

  .description-addto-campaign-cost-text {
    color: var(--Colors-Text-300, #5b5e5d);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 14.2px;
  }

  .description-addto-campaign-cost-price .ant-typography {
    color: var(--Colors-Text-500, #0a0f0d);
    font-size: var(--Font-Font-Size-h6, 18px);
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
  .selected-days {
    color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  .product-title {
    font-size: 14px !important;
    font-weight: bold;
  }
  .login-to-access-campaign-popover-tittle.ant-typography {
    color: #000;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-align: center;
    max-width: 100%;
  }
  .login-to-access-campaign-popover-text.ant-typography {
    color: #000;
    text-align: center !important;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 0.5rem;
  }
}

@media screen and (max-width: 320px) {
  .product-information-card {
    width: calc(100% - 36px);
    max-width: 100% !important;
    height: auto !important;
    min-height: 720px !important;
    max-height: 1640px !important;
    flex-shrink: 0;
    margin-left: 16px !important;
    margin-right: 12px !important;
    margin-top: 1rem !important;
  }

  .product-information-card-label {
    font-size: 14px;
    font-weight: 300px;
  }

  .product-information-card-value {
    font-size: 14px;
    font-weight: 400px;
  }

  .product-information-card-col {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }

  .description-addto-campaign-cost-text {
    color: var(--Colors-Text-300, #5b5e5d);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 10.2px;
  }

  .description-addto-campaign-cost-price .ant-typography {
    color: var(--Colors-Text-500, #0a0f0d);
    font-size: var(--Font-Font-Size-h6, 16px);
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
  .create-new-campaign-tittle {
    color: #000;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 550;
    line-height: normal;
    margin-bottom: 25px;
  }
  .selected-days {
    color: #000;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  .product-title {
    font-size: 13px !important;
    font-weight: bold;
  }
  .login-to-access-campaign-popover-tittle.ant-typography {
    color: #000;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-align: center;
    max-width: 100%;
  }
}
.oops-container {
  display: flex;
  padding: 26px 20px 17px 20px;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
  border-radius: 10px;
  background: #fff;
}
.oops-msg-test {
  color: #000;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  opacity: 0.8;
}
.warningPopup-div .ant-modal-content {
  padding: 0px;
}
.oops-warning-close-btn {
  display: flex;
  height: 40px;
  padding: 8px 20px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 5px;
  background: #d2042d;
}
.oops-warning-close-btn-text {
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.warningPopup-modal .ant-modal-content {
  padding: 0%;
}
.select-campaign-apply-btn {
  background-color: #d2042d;
}

.select-campaign-apply-btn:hover {
  background-color: #d2042d !important;
}

.mobile-create-new-campaign-btn:hover {
  background-color: #fff !important;
}
.mobile-add-to-campaign-btn:disabled {
  background-color: #d2042d !important;
  color: #fff !important;
}
.cancel-calendar-btn.ant-btn-primary:hover {
  background-color: #fff !important;
}
.create-new-btn-parent {
  display: flex;
  flex-direction: row;
  align-content: flex-end;
  justify-content: center;
}
.create-new-campaign-cancel-btn:hover {
  background-color: #fff !important;
}

.custom-calendar-popup-css .ant-picker-panel-container {
  width: 90% !important;
  margin-left: 25% !important;
}

.custom-calendar-mobile.ant-picker .ant-picker-clear {
  display: none !important;
  visibility: hidden !important;
}

.disable-input-click .ant-picker-input input {
  pointer-events: none;
  cursor: default;
}
.custom-calendar-popup .ant-picker-date-panel {
  width: 100% !important;
}

.create-new-campaign-model {
  max-width: calc(100vw - 65px);
  margin: 8px auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/product-details/mobile/ProductDetailsCard.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,cAAc;EACd,gCAAgC;EAChC,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gDAAgD;EAChD,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;;EAEzC,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,sCAAsC;;EAEtC,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;;EAEX,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gDAAgD;EAChD,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,sCAAsC;;EAEtC,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;;EAEX,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gDAAgD;EAChD,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;;EAEtC,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;;EAEtC,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,OAAO;EACP,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,QAAQ;EACR,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;EAEE,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,wBAAwB;EACxB,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,8BAA8B;AAChC;AACA;;EAEE,gBAAgB;EAChB,WAAW;AACb;AACA;;EAEE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,WAAW;;EAEX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,8BAA8B;EAC9B,UAAU;EACV,6BAA6B;EAC7B,4BAA4B;EAC5B,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;AACnC;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;;;;EAIE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,cAAc;EACd,UAAU;EACV,6BAA6B;EAC7B,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;IAChB,2BAA2B;EAC7B;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gDAAgD;EAChD,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;;EAEtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;;EAEtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;;EAEjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,sCAAsC;EACtC,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE;IACE,sBAAsB;IACtB,8BAA8B;IAC9B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,8BAA8B;IAC9B,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,6BAA6B;EAC/B;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,uBAAuB;IACvB,4BAA4B;IAC5B,mCAAmC;IACnC,cAAc;IACd,4BAA4B;IAC5B,6BAA6B;IAC7B,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,SAAS;IACT,OAAO;IACP,WAAW;IACX,YAAY;;IAEZ,aAAa;IACb,cAAc;IACd,gCAAgC;IAChC,gBAAgB;IAChB,iDAAiD;EACnD;;EAEA;IACE,sCAAsC;;IAEtC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,sCAAsC;IACtC,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,+BAA+B;EACjC;EACA;IACE,sCAAsC;IACtC,4CAA4C;IAC5C,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,4CAA4C;IAC5C,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,sCAAsC;IACtC,4CAA4C;IAC5C,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,sCAAsC;IACtC,4CAA4C;IAC5C,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,4BAA4B;IAC5B,4BAA4B;EAC9B;;EAEA;IACE,eAAe;IACf,8BAA8B;IAC9B,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sCAAsC;IACtC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,sCAAsC;;IAEtC,yCAAyC;IACzC,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA,yBAAyB;AACzB;EACE;IACE,sBAAsB;IACtB,8BAA8B;IAC9B,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,8BAA8B;IAC9B,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,uBAAuB;IACvB,4BAA4B;IAC5B,mCAAmC;IACnC,cAAc;IACd,4BAA4B;IAC5B,6BAA6B;IAC7B,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA;IACE,sCAAsC;IACtC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,sCAAsC;IACtC,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,WAAW;IACX,6BAA6B;IAC7B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;AACF;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,uBAAuB;IACvB,4BAA4B;IAC5B,6BAA6B;IAC7B,cAAc;IACd,4BAA4B;IAC5B,6BAA6B;IAC7B,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,8BAA8B;IAC9B,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,8BAA8B;IAC9B,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sCAAsC;IACtC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,sCAAsC;IACtC,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,WAAW;IACX,6BAA6B;IAC7B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,uBAAuB;IACvB,4BAA4B;IAC5B,6BAA6B;IAC7B,cAAc;IACd,4BAA4B;IAC5B,6BAA6B;IAC7B,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,sCAAsC;IACtC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,sCAAsC;IACtC,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;AACF;AACA;EACE,aAAa;EACb,4BAA4B;EAC5B,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;AACA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB","sourcesContent":[".product-details-main-div {\n  padding-bottom: 110px;\n  overflow-x: hidden !important;\n}\n\n.product-details-div {\n  display: flex;\n  flex-direction: column;\n  height: 150vh;\n  overflow: hidden;\n  padding: 25px 228px 22px 18px;\n  align-items: center;\n  flex-shrink: 0;\n  background: #f5f5f5;\n}\n.select-campaign-drawer-title {\n  color: #000;\n  font-family: Montserrat;\n  font-size: 19px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.product-details-arrow-and-text-row {\n  display: flex;\n  align-items: center;\n  margin-bottom: 15px;\n  margin-left: -14px;\n}\n.product-details-back-button-details {\n  padding-left: 0px;\n  padding-right: 0px;\n}\n.product-date-arrow-outlined {\n  margin-left: 3% !important;\n  margin-right: 3% !important;\n  stroke-width: 1px !important;\n  color: #d2042d !important;\n}\n.fixed-addto-campaign-btn-card {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  z-index: 100;\n  width: 430px;\n  height: 148px;\n  flex-shrink: 0;\n  border-radius: 10px 10px 0px 0px;\n  background: #fff;\n  box-shadow: 0px -2px 30px 0px rgba(0, 0, 0, 0.21);\n}\n\n.product-details-arrow-and-text-div {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 5px;\n  margin-top: 1rem !important;\n  margin-left: 20px !important;\n}\n\n.product-details-back-icon {\n  height: 0px;\n  flex-shrink: 0;\n  stroke-width: 2px;\n  stroke: #000;\n  width: 30px !important;\n  margin-left: 1rem !important;\n  margin-top: -2rem !important;\n}\n\n.product-details-arrow-and-text-div .product-details-heading {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-family: Montserrat;\n  font-size: var(--Font-Font-Size-h6, 19px);\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin-top: -1.6rem !important;\n  margin-left: -2% !important;\n}\n\n.product-availabale-card {\n  width: calc(100% - 36px);\n  max-width: 394px;\n  height: auto;\n  flex-shrink: 0;\n  border-radius: 10px;\n  background: #fff;\n  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.08);\n  margin-left: 18px !important;\n  margin-right: 18px !important;\n  margin-top: -0.5rem !important;\n}\n\n.product-iamge-card {\n  width: calc(100% - 36px);\n  max-width: 394px;\n  height: auto;\n  flex-shrink: 0;\n  border-radius: 10px;\n  margin-left: 18px !important;\n  margin-right: 18px !important;\n  margin-top: 0.5rem !important;\n}\n\n.product-data-div {\n  margin-left: -1% !important;\n}\n\n.product-id {\n  color: var(--Colors-Primary-500, #d2042d);\n\n  font-size: var(--Font-Font-Size-small, 13px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.product-title {\n  color: #000;\n  font-size: var(--Font-Font-Size-p, 14px);\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin-top: 1% !important;\n}\n\n.product-available-from {\n  width: 86px;\n  color: var(--Colors-Text-200, #8e9190);\n\n  font-size: var(--Font-Font-Size-small, 13px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.product-available-dates {\n  color: #000;\n\n  font-size: var(--Font-Font-Size-small, 13px);\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.no-of-selected-days-card .ant-card {\n  max-width: 394px;\n  width: calc(100% - 36px);\n  flex-shrink: 0;\n  border-radius: 10px;\n  background: #fff;\n  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.08);\n  margin-left: 18px !important;\n  margin-right: 18px !important;\n  margin-top: 1rem !important;\n}\n.centered-col-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.scrollable-col-container {\n  display: flex;\n  overflow-x: auto;\n  gap: 10px;\n}\n\n.no-of-days-selected-heading {\n  color: var(--Colors-Text-300, #5b5e5d);\n\n  font-size: var(--Font-Font-Size-small, 13px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.available-dates-div .dates-btn-arrow .anticon {\n  width: 11px;\n  height: 0px;\n  flex-shrink: 0;\n  stroke-width: 1px;\n  stroke: var(--Colors-Primary-500, #d2042d);\n}\n\n.selected-days {\n  color: #000;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  color: #000;\n\n  font-size: var(--Font-Font-Size-small, 13px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.product-saved-campaign-card .ant-card {\n  max-width: 394px;\n  height: 84px;\n  width: calc(100% - 36px);\n  flex-shrink: 0;\n  border-radius: 10px;\n  background: #fff;\n  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.08);\n  margin-left: 18px !important;\n  margin-right: 18px !important;\n  margin-top: 1rem !important;\n}\n\n.no-of-selected-days-heading {\n  color: var(--Colors-Text-300, #5b5e5d);\n\n  font-size: var(--Font-Font-Size-small, 13px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.select-campaign-heading {\n  color: var(--Colors-Text-300, #5b5e5d);\n\n  font-size: var(--Font-Font-Size-small, 13px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.select-campaign-existing-list {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 10px 0;\n  gap: 16px !important;\n}\n.campaign-drawer-mobile .ant-drawer-body {\n  padding-top: 0% !important;\n}\n.radio-list {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n.radio-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  display: flex;\n  gap: 2%;\n  flex-wrap: nowrap;\n}\n.select-campaign-existing-list-rdio-btn {\n  width: 4%;\n  order: 2;\n  margin-left: 34rem;\n  transform: scale(1.3);\n}\n.select-campaign-existing-list-rdio-btn .ant-radio-inner {\n  width: 1rem !important;\n  height: 1rem !important;\n}\n\n.select-campaign-existing-list-rdio-btn .ant-radio {\n  transform: scale(1.5);\n}\n.select-campaign-existing-list .ant-radio {\n  order: 1;\n  margin-inline-end: 2rem !important;\n}\n\n.select-campaign-existing-list span {\n  white-space: nowrap;\n}\n\n.select-campaign-existing-list .campaign-radio-btn-grp {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem !important;\n  width: 100%;\n}\n\n.select-campaign-existing-list .ant-radio-wrapper span.ant-radio + * {\n  padding-inline-start: 8px;\n  padding-inline-end: 10rem;\n}\n\n.select-campaign-existing-list-text {\n  width: 80%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  color: var(--Colors-Text-400, #3b3f3d);\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.campaign-divider-mobile {\n  border-radius: 1px solid !important;\n}\n.select-campaign-apply-btn {\n  display: flex;\n  height: 3.125rem;\n  padding: 0.5rem 2.125rem;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  flex-shrink: 0;\n  border-radius: 0.3125rem;\n  background: #d2042d;\n  margin-bottom: 1rem;\n  width: 100% !important;\n}\n\n.select-campaign-existing-list {\n  flex: 1;\n  max-height: 60vh;\n  overflow-y: auto;\n  padding: 10px;\n  border-bottom: 2px solid #ddd;\n  overflow-x: hidden;\n}\n\n.radio-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.radio-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 0.5rem 0;\n}\n\n.select-campaign-existing-list-text {\n  color: var(--Colors-Text-400, #3b3f3d);\n  font-size: 1rem;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.select-campaign-existing-list-rdio-btn {\n  transform: scale(1.3);\n  margin-left: 0;\n}\n\n.campaign-drawer-mobile .ant-drawer-body {\n  padding-top: 0% !important;\n}\n.select-campaign-container {\n  display: flex;\n  flex-direction: column;\n  height: 125%;\n  padding: 0px 18px;\n}\n.select-campaign-footer {\n  bottom: 0;\n}\n\n.select-campaign-apply-btn-text {\n  color: #fff;\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.create-new-campaign-tittle {\n  color: #000;\n  font-family: Montserrat;\n  font-size: 19px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin-bottom: 25px;\n}\n.create-new-campaign-row {\n  margin-bottom: 5% !important;\n  margin-top: 20px;\n}\n.create-new-campaign-cancel-btn .ant-btn-variant-solid {\n  display: flex;\n  width: 132px;\n  height: 40px;\n  padding: 8px 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  border-radius: 5px;\n  background: #fff;\n}\n\n.create-new-campaign-cancel-btn {\n  display: flex;\n  width: 100%;\n  height: 40px;\n  padding: 8px 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  border: 1px solid #000;\n  background: #fff;\n}\n\n.create-new-campaign-cancel-btn:focus,\n.create-new-campaign-cancel-btn:active {\n  background-color: none !important;\n}\n.mobile-create-new-campaign-btn {\n  display: flex;\n  height: 3.125rem;\n  padding: 0.5rem 2.125rem;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  flex-shrink: 0;\n  border-radius: 0.3125rem;\n  border: 1px solid #000;\n  background: #fff !important;\n  width: 100%;\n}\n\n.create-new-campaign-cancel-btn-text {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.mobile-create-new-campaign-btn-text {\n  color: #0a0f0d;\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.new-create-campaign-btn-container {\n  margin-top: 20px;\n}\n.create-new-campaign-confirm-btn-text {\n  color: #fff;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.create-new-campaign-confirm-btn.ant-btn-variant-solid {\n  display: flex;\n  width: 100%;\n  height: 40px;\n  padding: 8px 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  border-radius: 5px;\n  background: #d2042d !important;\n}\n.create-new-capaign-col-cancel\n  .ant-btn-variant-solid:not(:disabled):not(.ant-btn-disabled):hover {\n  background: #fff;\n  color: #fff;\n}\n.create-new-capaign-col-confirm\n  .ant-btn-variant-solid:not(:disabled):not(.ant-btn-disabled):active {\n  background: #d2042d;\n  color: #fff;\n}\n.selected-days {\n  color: #000;\n\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.campaign-list {\n  color: #000;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.calendar-container {\n  border: none !important;\n}\n.ant-picker-dropdown .ant-picker-cell-disabled::before {\n  background: none !important;\n}\n\n.calendar-main-row {\n  margin-top: -1rem !important;\n}\n\n.date-picker-calendar {\n  border: none !important;\n}\n\n.custom-date-picker {\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n}\n\n.custom-date-picker .ant-picker-suffix {\n  border: none !important;\n  background: none !important;\n  padding: 0;\n  box-shadow: none;\n}\n\n.custom-date-picker .ant-picker-input {\n  display: none;\n}\n\n.custom-calendar-popup-mobile .ant-picker-panel-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center !important;\n  align-items: center !important;\n  width: 90%;\n  margin-right: auto !important;\n  margin-left: auto !important;\n  height: auto !important;\n  flex-shrink: 0;\n  box-shadow: none;\n  border-radius: 12.133px;\n  border: 1.213px solid #ddd;\n  background: #fff;\n  caret-color: transparent !important;\n}\n\n.ant-picker-input > input {\n  caret-color: transparent !important;\n  cursor: pointer;\n}\n\n.custom-calendar-popup-mobile .ant-picker-panel {\n  width: 100%;\n}\n\n.custom-calendar-popup-mobile .ant-picker-panel:nth-child(2) {\n  display: none !important;\n}\n\n.create-new-capaign-col-cancel .ant-btn-primary:hover {\n  background-color: none !important;\n}\n.selected-days-heading {\n  font-size: 14px;\n  font-weight: bold;\n  color: #555;\n}\n\n.custom-calendar-popup-mobile .ant-picker-cell-selected .ant-picker-cell-inner {\n  background-color: transparent !important;\n  box-shadow: none !important;\n  border: none !important;\n}\n\n.custom-calendar-popup-mobile .ant-picker-cell-selected .ant-picker-cell-inner {\n  background-color: #d2042d !important;\n  color: white !important;\n  border: #d2042d !important;\n}\n\n.custom-calendar-popup-mobile\n  .ant-picker-dropdown\n  .ant-picker-cell-in-view.ant-picker-cell-today\n  .ant-picker-cell-inner::before {\n  border: none !important;\n}\n\n.custom-calendar-mobile.ant-picker-outlined {\n  border: none !important;\n  justify-content: end;\n  padding: 0;\n  margin: 0;\n}\n\n.custom-calendar-mobile.ant-picker .ant-picker-suffix {\n  color: white !important;\n  opacity: 1 !important;\n  /* display: none !important; */\n}\n\n.custom-calendar-mobile .ant-picker-selector {\n  display: none !important;\n}\n\n.custom-calendar-mobile .ant-picker-input {\n  display: none !important;\n}\n\n.confirm-calendar-btn-text {\n  color: #fff;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.cancel-calendar-btn-text {\n  color: #fff;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.confirm-calendar-btn.ant-btn-variant-solid {\n  display: flex;\n  width: 132px;\n  height: 40px;\n  padding: 8px 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  border-radius: 5px;\n  background: #d2042d;\n}\n\n.cancel-calendar-btn.ant-btn-variant-solid {\n  display: flex;\n  width: 132px;\n  height: 40px;\n  padding: 8px 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  border-radius: 5px;\n  background: #d2042d;\n}\n\n.cancel-calendar-btn {\n  display: flex;\n  width: 132px;\n  height: 40px;\n  padding: 8px 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  border-radius: 5px;\n  background: #d2042d;\n}\n\n.cancel-calendar-btn:focus,\n.cancel-calendar-btn:active {\n  background-color: none !important;\n}\n\n.calender-icon {\n  padding: 0;\n  margin: 0;\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n  fill: #000;\n  position: absolute !important;\n  right: 10px !important;\n  top: 10px !important;\n  cursor: pointer;\n}\n.add-to-campaign-btn-version {\n  text-align: center;\n  margin-top: 10px !important;\n}\n.calendar-footer-btn-row {\n  margin-bottom: 5% !important;\n  margin-left: 0.7rem !important;\n}\n\n.custom-calendar-popup-mobile .ant-picker-content th {\n  color: #b3b3b3;\n  text-align: center;\n  font-size: 15.967px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  width: 41.761px;\n  height: 41.761px;\n  flex-shrink: 0;\n}\n\n.custom-calendar-popup-mobile\n  .ant-picker-cell-today\n  .ant-picker-cell-inner::before {\n  border: none !important;\n}\n\n.custom-calendar-popup-mobile .ant-picker-cell-today .ant-picker-cell-inner {\n  border: 1px solid #d2042d !important;\n}\n\n.calendar-btns-above-divider {\n  width: 282.5px;\n  height: 0px;\n  flex-shrink: 0;\n  stroke-width: 0.614px;\n  stroke: #a3a3a6;\n}\n\n.custom-calendar-popup-mobile .ant-picker-header {\n  padding: 0px 18px;\n  width: 100% !important;\n}\n\n.custom-calendar-popup-mobile .ant-picker-header-prev-btn,\n.custom-calendar-popup-mobile .ant-picker-header-next-btn {\n  justify-content: center;\n}\n\n.date-picker-calendar .ant-picker-outlined:hover {\n  border-color: none !important;\n}\n\n.mobile-image-scrollable-container {\n  display: flex;\n  overflow-x: auto;\n  white-space: nowrap;\n  padding: 10px;\n  gap: 16px;\n  margin-left: 0.5rem !important;\n  width: 100%;\n}\n\n.scrollable-col-container {\n  display: flex;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n}\n\n.images-width-div {\n  width: calc(100% - 7px);\n  max-width: 400px;\n}\n\n.scrollable-col-container::-webkit-scrollbar {\n  display: none;\n}\n\n.image-wrapper {\n  display: flex;\n  gap: 16px;\n}\n\n.mobile-billboard-img {\n  width: 100%;\n  max-width: 252px;\n  height: 150px;\n  flex-shrink: 0;\n  border-radius: 10px;\n}\n\n@media (max-width: 768px) {\n  .scrollable-col-container {\n    overflow-x: auto;\n    justify-content: flex-start;\n  }\n  .mobile-billboard-img {\n    width: 100%;\n    max-width: 252px;\n    height: 150px;\n    flex-shrink: 0;\n    border-radius: 10px;\n  }\n}\n\n@media (min-width: 768px) {\n  .scrollable-col-container {\n    justify-content: center;\n  }\n}\n\n.product-information-card {\n  width: calc(100% - 36px);\n  min-height: 720px !important;\n  max-width: 394px;\n  height: auto !important;\n  flex-shrink: 0;\n  border-radius: 10px;\n  background: #fff;\n  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.08);\n  margin-left: 18px !important;\n  margin-right: 18px !important;\n  margin-top: 1rem !important;\n}\n\n.product-information-card-row {\n  margin-top: 2% !important;\n}\n\n.product-information-card-label {\n  align-self: stretch;\n  color: var(--Colors-Text-200, #8e9190);\n\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.product-information-card-value {\n  align-self: stretch;\n  color: var(--Colors-Text-500, #0a0f0d);\n\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n\n  margin-top: 2% !important;\n}\n\n.input-group {\n  margin-bottom: 15px;\n}\n\n.billboard-img {\n  width: 100%;\n  border-radius: 10px;\n}\n\n.price-footer {\n  text-align: center;\n  margin-top: 20px;\n}\n\n.description-addto-campaign-btn {\n  width: 316px;\n}\n\n.description-addto-campaign-btn\n  .description-addto-campaign-cost-text\n  .ant-typography {\n  color: var(--Colors-Text-300, #5b5e5d);\n  font-size: var(--Font-Font-Size-small, 77px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18.2px;\n}\n\n.description-addto-campaign-cost-price {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-size: var(--Font-Font-Size-h6, 19px);\n  font-style: normal;\n  font-weight: 800;\n  line-height: normal;\n}\n.mobile-add-to-campaign-btn:hover {\n  background-color: #d2042d !important;\n  color: #fff;\n}\n\n@media (max-width: 768px) {\n  .product-details-back-icon {\n    width: 35px !important;\n    margin-top: -2.2rem !important;\n    margin-left: 1.2rem !important;\n  }\n\n  .product-details-arrow-and-text-div .product-details-heading {\n    font-size: 20px !important;\n    margin-top: -1.6rem !important;\n    margin-left: -2% !important;\n  }\n\n  .product-availabale-card {\n    max-width: 100%;\n    margin-right: 2rem !important;\n  }\n\n  .product-details-heading .ant-typography h1 {\n    font-size: 25px;\n    font-weight: 700;\n  }\n\n  .no-of-selected-days-card .ant-card {\n    max-width: 100%;\n  }\n\n  .product-saved-campaign-card .ant-card {\n    max-width: 100%;\n  }\n\n  .product-information-card {\n    width: calc(100% - 36px);\n    max-width: 100% !important;\n    height: auto !important;\n    min-height: 720px !important;\n    /* max-height: 1430px !important; */\n    flex-shrink: 0;\n    margin-left: 17px !important;\n    margin-right: 12px !important;\n    margin-top: 1rem !important;\n  }\n\n  .product-information-card-row {\n    margin-top: 1% !important;\n  }\n\n  .product-information-card-label {\n    font-size: 20px;\n    font-weight: 400px;\n  }\n\n  .product-information-card-value {\n    font-size: 16px;\n    font-weight: 500px;\n  }\n\n  .product-information-card-col {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n  }\n\n  .product-information-card-label {\n    margin-right: 10px;\n  }\n\n  .mobile-billboard-img {\n    max-width: 100% !important;\n  }\n\n  .fixed-addto-campaign-btn-card {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    z-index: 100;\n\n    height: 148px;\n    flex-shrink: 0;\n    border-radius: 10px 10px 0px 0px;\n    background: #fff;\n    box-shadow: 0px -2px 30px 0px rgba(0, 0, 0, 0.21);\n  }\n\n  .description-addto-campaign-cost-text {\n    color: var(--Colors-Text-300, #5b5e5d);\n\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 18.2px;\n  }\n\n  .description-addto-campaign-cost-price .ant-typography {\n    color: var(--Colors-Text-500, #0a0f0d);\n    font-size: var(--Font-Font-Size-h6, 20px);\n    font-style: normal;\n    font-weight: 800;\n    line-height: normal;\n  }\n\n  .mobile-add-to-campaign-btn {\n    font-size: 20px;\n    font-weight: 500px;\n    color: #fff;\n    display: flex;\n    width: 100%;\n    height: 50px;\n    padding: 8px 20px;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    flex-shrink: 0;\n    border-radius: 5px;\n    opacity: 0.5;\n    background: #d2042d;\n    margin-right: -10rem !important;\n  }\n  .no-of-selected-days-heading {\n    color: var(--Colors-Text-300, #5b5e5d);\n    font-size: var(--Font-Font-Size-small, 16px);\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }\n  .product-available-dates {\n    color: #000;\n    font-size: var(--Font-Font-Size-small, 16px);\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }\n  .product-available-from {\n    width: 86px;\n    color: var(--Colors-Text-200, #8e9190);\n    font-size: var(--Font-Font-Size-small, 16px);\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }\n  .select-campaign-heading {\n    color: var(--Colors-Text-300, #5b5e5d);\n    font-size: var(--Font-Font-Size-small, 16px);\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .product-details-back-icon {\n    width: 32px !important;\n    margin-top: -2rem !important;\n    margin-left: 1rem !important;\n  }\n\n  .product-details-arrow-and-text-div .product-details-heading {\n    font-size: 19px;\n    margin-top: -1.5rem !important;\n    margin-left: -2% !important;\n  }\n\n  .product-availabale-card {\n    width: calc(100% - 36px);\n  }\n\n  .description-addto-campaign-cost-text {\n    color: var(--Colors-Text-300, #5b5e5d);\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 18.2px;\n  }\n\n  .description-addto-campaign-cost-price .ant-typography {\n    color: var(--Colors-Text-500, #0a0f0d);\n\n    font-size: var(--Font-Font-Size-h6, 20px);\n    font-style: normal;\n    font-weight: 8000;\n    line-height: normal;\n  }\n}\n\n/* 📱 Small Mobile View */\n@media (max-width: 425px) {\n  .product-details-back-icon {\n    width: 30px !important;\n    margin-top: -1.8rem !important;\n    margin-left: 0.8rem !important;\n  }\n\n  .product-details-arrow-and-text-div .product-details-heading {\n    font-size: 18px;\n    margin-top: -1.4rem !important;\n    margin-left: -1.5% !important;\n  }\n\n  .product-availabale-card {\n    width: calc(100% - 36px);\n  }\n\n  .product-information-card {\n    width: calc(100% - 36px);\n    max-width: 100% !important;\n    height: auto !important;\n    min-height: 720px !important;\n    /* max-height: 1430px !important; */\n    flex-shrink: 0;\n    margin-left: 16px !important;\n    margin-right: 12px !important;\n    margin-top: 1rem !important;\n  }\n\n  .product-information-card-label {\n    font-size: 16px;\n    font-weight: 400px;\n  }\n\n  .product-information-card-value {\n    font-size: 14px;\n    font-weight: 400px;\n  }\n\n  .product-information-card-col {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n  }\n\n  .product-information-card-label {\n    margin-right: 10px;\n  }\n\n  .no-of-selected-days-card .ant-card {\n    max-width: 100%;\n  }\n\n  .product-saved-campaign-card .ant-card {\n    max-width: 100%;\n  }\n\n  .ant-card-body .product-information-card-row {\n    margin-left: none !important;\n    margin-right: none !important;\n  }\n\n  .description-addto-campaign-cost-text {\n    color: var(--Colors-Text-300, #5b5e5d);\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 14.2px;\n  }\n\n  .description-addto-campaign-cost-price .ant-typography {\n    color: var(--Colors-Text-500, #0a0f0d);\n    font-size: var(--Font-Font-Size-h6, 18px);\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n  }\n  .create-new-campaign-tittle {\n    color: #000;\n    font-family: Montserrat;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 550;\n    line-height: normal;\n    margin-bottom: 25px;\n  }\n  .selected-days {\n    color: #000;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }\n  .login-to-access-campaign-popover-tittle.ant-typography {\n    color: #000;\n    font-family: Montserrat;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    text-align: center;\n    max-width: 100%;\n  }\n  .login-to-access-campaign-popover-text.ant-typography {\n    color: #000;\n    text-align: center !important;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 1rem;\n  }\n}\n.product-version-spin {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n@media screen and (max-width: 375px) {\n  .product-information-card {\n    width: calc(100% - 36px);\n    max-width: 100% !important;\n    height: auto !important;\n    min-height: 720px !important;\n    max-height: 1540px !important;\n    flex-shrink: 0;\n    margin-left: 16px !important;\n    margin-right: 12px !important;\n    margin-top: 1rem !important;\n  }\n\n  .product-details-back-icon {\n    width: 28px !important;\n    margin-top: -1.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n\n  .product-details-arrow-and-text-div .product-details-heading {\n    font-size: 17px;\n    margin-top: -1.2rem !important;\n    margin-left: -1% !important;\n  }\n\n  .product-availabale-card {\n    width: calc(100% - 36px);\n  }\n\n  .no-of-selected-days-card .ant-card {\n    max-width: 100%;\n  }\n\n  .product-saved-campaign-card .ant-card {\n    max-width: 100%;\n  }\n\n  .description-addto-campaign-cost-text {\n    color: var(--Colors-Text-300, #5b5e5d);\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 14.2px;\n  }\n\n  .description-addto-campaign-cost-price .ant-typography {\n    color: var(--Colors-Text-500, #0a0f0d);\n    font-size: var(--Font-Font-Size-h6, 18px);\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n  }\n  .selected-days {\n    color: #000;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }\n  .product-title {\n    font-size: 14px !important;\n    font-weight: bold;\n  }\n  .login-to-access-campaign-popover-tittle.ant-typography {\n    color: #000;\n    font-family: Montserrat;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    text-align: center;\n    max-width: 100%;\n  }\n  .login-to-access-campaign-popover-text.ant-typography {\n    color: #000;\n    text-align: center !important;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 0.5rem;\n  }\n}\n\n@media screen and (max-width: 320px) {\n  .product-information-card {\n    width: calc(100% - 36px);\n    max-width: 100% !important;\n    height: auto !important;\n    min-height: 720px !important;\n    max-height: 1640px !important;\n    flex-shrink: 0;\n    margin-left: 16px !important;\n    margin-right: 12px !important;\n    margin-top: 1rem !important;\n  }\n\n  .product-information-card-label {\n    font-size: 14px;\n    font-weight: 300px;\n  }\n\n  .product-information-card-value {\n    font-size: 14px;\n    font-weight: 400px;\n  }\n\n  .product-information-card-col {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n  }\n\n  .description-addto-campaign-cost-text {\n    color: var(--Colors-Text-300, #5b5e5d);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 10.2px;\n  }\n\n  .description-addto-campaign-cost-price .ant-typography {\n    color: var(--Colors-Text-500, #0a0f0d);\n    font-size: var(--Font-Font-Size-h6, 16px);\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n  }\n  .create-new-campaign-tittle {\n    color: #000;\n    font-family: Montserrat;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 550;\n    line-height: normal;\n    margin-bottom: 25px;\n  }\n  .selected-days {\n    color: #000;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }\n  .product-title {\n    font-size: 13px !important;\n    font-weight: bold;\n  }\n  .login-to-access-campaign-popover-tittle.ant-typography {\n    color: #000;\n    font-family: Montserrat;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    text-align: center;\n    max-width: 100%;\n  }\n}\n.oops-container {\n  display: flex;\n  padding: 26px 20px 17px 20px;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 20px;\n  border-radius: 10px;\n  background: #fff;\n}\n.oops-msg-test {\n  color: #000;\n  text-align: center;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  opacity: 0.8;\n}\n.warningPopup-div .ant-modal-content {\n  padding: 0px;\n}\n.oops-warning-close-btn {\n  display: flex;\n  height: 40px;\n  padding: 8px 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  border-radius: 5px;\n  background: #d2042d;\n}\n.oops-warning-close-btn-text {\n  color: #fff;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.warningPopup-modal .ant-modal-content {\n  padding: 0%;\n}\n.select-campaign-apply-btn {\n  background-color: #d2042d;\n}\n\n.select-campaign-apply-btn:hover {\n  background-color: #d2042d !important;\n}\n\n.mobile-create-new-campaign-btn:hover {\n  background-color: #fff !important;\n}\n.mobile-add-to-campaign-btn:disabled {\n  background-color: #d2042d !important;\n  color: #fff !important;\n}\n.cancel-calendar-btn.ant-btn-primary:hover {\n  background-color: #fff !important;\n}\n.create-new-btn-parent {\n  display: flex;\n  flex-direction: row;\n  align-content: flex-end;\n  justify-content: center;\n}\n.create-new-campaign-cancel-btn:hover {\n  background-color: #fff !important;\n}\n\n.custom-calendar-popup-css .ant-picker-panel-container {\n  width: 90% !important;\n  margin-left: 25% !important;\n}\n\n.custom-calendar-mobile.ant-picker .ant-picker-clear {\n  display: none !important;\n  visibility: hidden !important;\n}\n\n.disable-input-click .ant-picker-input input {\n  pointer-events: none;\n  cursor: default;\n}\n.custom-calendar-popup .ant-picker-date-panel {\n  width: 100% !important;\n}\n\n.create-new-campaign-model {\n  max-width: calc(100vw - 65px);\n  margin: 8px auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
